import type { Dictionary } from './types'

export const me: Dictionary = {
  meta: {
    title: 'CRAFT TOWER DOO | Razvoj softvera i IT usluge u Crnoj Gori',
    description:
      'CRAFT TOWER DOO je softverska i IT kompanija u Crnoj Gori. Razvijamo sajtove, aplikacije, automatizacije, poslovna rješenja i sigurnu infrastrukturu za pojedince i kompanije.',
  },
  nav: {
    services: 'Usluge',
    work: 'Radovi',
    process: 'Proces',
    about: 'O nama',
    contact: 'Kontakt',
    menu: 'Meni',
    close: 'Zatvori',
    skip: 'Preskoči na sadržaj',
  },
  ui: {
    language: 'Jezik',
    theme: 'Promijeni svijetlu / tamnu temu',
    cyber: 'Sajber režim',
    cyberHint: 'GO CYBER,\nTRY ME!',
    cyberBoot: '> POVEZIVANJE… MREŽA AKTIVNA_',
    localTime: 'Bar',
    backToTop: 'Nazad na vrh',
    loading: 'Sklapanje',
  },
  hero: {
    badge: 'Crnogorski softverski studio u Baru',
    title: 'Pouzdan softver za',
    titleAccent: 'stvaran rad',
    description:
      'U CRAFT TOWER projektujemo i razvijamo sajtove, poslovne alate, automatizacije i tehnička rješenja za pojedince i rastuće kompanije u Crnoj Gori i inostranstvu.',
    ctaPrimary: 'Pokrenimo projekat',
    ctaSecondary: 'Izabrani radovi',
    slogan: 'Stvaramo kod. Gradimo budućnost.',
  },
  proofs: [
    { label: 'Osnovano', value: '13.08.2021.' },
    { label: 'Baza', value: 'Bar, Crna Gora' },
    { label: 'Jezici', value: 'Engleski, crnogorski, ruski' },
    { label: 'Fokus', value: 'Namjenski softver i IT podrška' },
  ],
  marquee: ['Sajtovi', 'Sistemi za rezervacije', 'Klijentski portali', 'Administrativni paneli', 'AI procesi', 'Automatizacija', 'Mreže', 'IT podrška'],
  services: {
    label: 'Usluge',
    title: 'Sajtovi, interni alati, automatizacija i IT podrška.',
    description:
      'Bilo da vam treba brzi kompanijski sajt, sistem za rezervacije, klijentski portal, administrativni panel ili pametniji interni proces, CRAFT TOWER gradi praktične sisteme za svakodnevni rad.',
    individualsButton: 'Za pojedince',
    businessButton: 'Za male biznise',
    focus: 'U fokusu',
    individuals: [
      {
        eyebrow: 'Lični projekti',
        title: 'Sajtovi, kontrolni paneli i privatni alati',
        summary: 'Za frilensere, kreatore, porodice i specifične zajednice kojima treba nešto korisnije od običnog šablona.',
        bullets: ['Lični sajtovi i portfolio stranice', 'Privatni alati za praćenje, kontrolni paneli i portali', 'Forme, mape, botovi i API integracije'],
        focus: ['Moderni portfolio sajtovi', 'Prilagođeni lični kontrolni paneli', 'Trekeri i asistenti za RPG i društvene igre'],
      },
      {
        eyebrow: 'Praktična podrška',
        title: 'IT postavka i svakodnevna digitalna pomoć',
        summary: 'Za ljude koji žele pouzdan sistem, sigurnije uređaje i manje problema u svakodnevnom digitalnom radu.',
        bullets: ['Podešavanje uređaja i softvera', 'Bezbjednosne kopije, lozinke i kućna mreža', 'Praktična pomoć sa AI i alatima za automatizaciju'],
        focus: ['Samo ono što vam je zaista potrebno za rad', 'Bezbjednost je prioritet', 'Ubrzajte i automatizujte svoju svakodnevicu'],
      },
    ],
    business: [
      {
        eyebrow: 'Sistemi za klijente',
        title: 'Veb prisustvo, rezervacije i prikupljanje kontakata',
        summary: 'Za male firme kojima je bitan odličan prvi utisak i jednostavnija komunikacija sa klijentima.',
        bullets: ['Kompanijski sajtovi i odredišne stranice', 'Rezervacije, upiti i proces izrade ponuda', 'Struktura optimizovana za SEO i analitika'],
        focus: ['Moderan dizajn uz najbolje SEO prakse', 'Efikasni i korisni kontrolni paneli', 'Analiza podataka i poboljšanje performansi'],
      },
      {
        eyebrow: 'Interna organizacija',
        title: 'Poslovni alati, automatizacije i infrastruktura',
        summary: 'Za timove kojima trebaju efikasni sistemi za smanjenje manuelnog rada i bolju preglednost poslovanja.',
        bullets: ['Namjenski admin paneli i interni alati', 'AI radni procesi i automatizacija', 'Mreže, uređaji i cloud podrška'],
        focus: ['Čisti, prilagođeni interfejsi', 'Najefikasniji automatizovani radni procesi', 'Pouzdan tehnički rad i podrška'],
      },
    ],
  },
  work: {
    label: 'Radovi',
    title: 'Izabrani radovi',
    description:
      'Snimci ekrana, promo video zapisi i priče iza proizvoda koje razvijamo. Ovde možete videti neke od naših projekata.',
    projects: 'Projekti',
    loadMore: 'Prikaži još',
    soon: 'Uskoro: više radova u izradi',
    highlights: 'Šta smo izgradili',
    viewCase: 'Pogledaj projekat',
    status: { concept: 'Koncept', 'in-progress': 'U izradi', live: 'Uživo' },
    links: { live: 'Sajt uživo', case: 'Studija slučaja', repo: 'Izvorni kod', store: 'Prodavnica aplikacija' },
    promo: 'Promo video',
    outcome: 'Rezultat',
    scope: 'Obim',
    stack: 'Tehnologije',
    client: 'Klijent',
    year: 'Godina',
    category: 'Kategorija',
    screens: 'Ekrani',
    screensSoon: 'Snimci ekrana i promo video za ovaj projekat biće dodati uskoro.',
    prevScreen: 'Prethodni snimak ekrana',
    nextScreen: 'Sljedeći snimak ekrana',
    prev: 'Prethodni projekat',
    next: 'Sljedeći projekat',
    close: 'Zatvori',
  },
  process: {
    label: 'Proces',
    title: 'Kako projekat napreduje',
    readout: 'Napredak izgradnje',
    phases: ['Otkrivanje', 'Dizajn', 'Razvoj', 'Testiranje', 'Lansiranje'],
    steps: [
      'Intro razgovor i okvir projekta',
      'Inicijalni UI dizajn i arhitektura',
      'Razvoj funkcionalnosti i iterativne verzije',
      'Provjera kvaliteta, performansi i sigurnosti',
      'Produkciono puštanje i praktična podrška',
    ],
  },
  about: {
    label: 'O nama',
    title: 'Naše vizije',
    p1: 'Tehnologija ne bi trebalo da bude komplikovana. U CRAFT TOWER-u vjerujemo da su IT i programiranje alati koji čine vaš život i poslovanje jednostavnijim i stabilnijim.',
    p2: 'Bilo da vam je potrebna namjenska veb aplikacija, implementacija vještačke inteligencije u svakodnevni rad ili sigurna i brza mreža, mi izbjegavamo korporativni žargon. Isporučujemo čist kod, stabilnu podršku i rješenja koja zaista rade.',
    sign: 'Andrey D',
    role: 'Osnivač',
    checklistTitle: 'Kako saradnja treba da izgleda',
    checklist: [
      'Jasno definisan obim projekta prije početka razvoja',
      'Otvorena saradnja kroz koncepte umjesto nagađanja',
      'Direktna komunikacija sa osobom koja razvija rješenje',
    ],
    company: 'Kompanija',
    founded: 'Osnovano',
    address: 'Adresa',
    addressValue: 'Šušanj b.b., 85000 Bar, Crna Gora',
  },
  contact: {
    label: 'Kontakt',
    titleLead: 'Gradimo rješenja koja su pouzdana, praktična i',
    titleAccent: 'brza.',
    description:
      'CRAFT TOWER je fokusiran na softverski inženjering i IT podršku koja donosi konkretnu vrijednost pojedincima i kompanijama.',
    cta: 'Razgovarajmo o projektu',
    email: 'Email',
    phone: 'Telefon / Viber / WhatsApp',
    web: 'Web',
    address: 'Adresa',
    form: {
      title: 'Pošaljite',
      highlight: 'poruku',
      subtitle: 'Imate ideju za projekat? Hajde da razgovaramo.',
      name: 'Puno ime',
      email: 'Email adresa',
      message: 'Poruka',
      namePlaceholder: 'Vaše ime',
      emailPlaceholder: 'vas@email.com',
      messagePlaceholder: 'Napišite nam detalje projekta...',
      send: 'Pošalji poruku',
      sending: 'Slanje…',
      success: 'Poruka je uspješno poslata! Javićemo vam se uskoro.',
      error: 'Došlo je do greške. Pokušajte ponovo.',
      invalid: 'Popunite sva polja i unesite ispravnu email adresu.',
    },
  },
  agent: {
    home: 'Zdravo! Treba vam sajt, alat ili automatizacija?',
    services: 'Izaberite za koga je — pokazaću šta odgovara.',
    work: 'Naš prvi pravi projekat, MonteGigs, je na početku. Stižu i drugi!',
    process: 'Sprat po sprat — tako gradimo.',
    about: 'Jasan obim, iskreni nacrti, direktan kontakt.',
    contact: 'Pišite nam o svojoj ideji — javićemo vam se.',
    sendMessage: 'Pošaljite poruku',
    openChat: 'Uživo Čat',
    onlineStatus: 'Na mreži',
    badgeText: 'CT-AGENT',
  },
  cookie: {
    badge: 'Privatnost i Bezbjednost',
    title: 'Cijenimo vašu privatnost i bezbjednost',
    description:
      'Koristimo kolačiće i lokalno skladište za sigurnost, pamćenje jezika i teme, te rad čata uživo. Bez marketinških i oglasnih pratilaca.',
    agentNote: 'Zaštićeno i bezbjedno: vaša podešavanja se čuvaju lokalno na vašem uređaju.',
    acceptAll: 'Prihvati sve',
    essentialOnly: 'Samo neophodni',
    managePreferences: 'Detalji i Privatnost',
    modalTitle: 'Podešavanje privatnosti i kolačića',
    modalSubtitle: 'Transparentne informacije o načinu na koji CRAFT TOWER DOO koristi kolačiće i lokalno skladište.',
    strictlyNecessary: 'Strogo neophodni kolačići',
    strictlyNecessaryDesc: 'Potrebni za rad sajta, izbor jezika, sigurnost i temu. Ne mogu se isključiti.',
    liveChat: 'Čat podrška uživo',
    liveChatDesc: 'Anonimni ID sesije za direktnu komunikaciju sa našim timom putem Telegrama.',
    analytics: 'Performanse i telemetrija',
    analyticsDesc: 'Anonimna statistika za optimizaciju brzine rada sajta u Crnoj Gori i globalno.',
    alwaysActive: 'Uvijek aktivno',
    dataController: 'Rukovalac podacima: CRAFT TOWER DOO (Šušanj b.b., 85000 Bar, Crna Gora) · info@craft-tower.com',
    savePreferences: 'Sačuvaj podešavanja',
    close: 'Zatvori',
    footerLink: 'Privatnost i kolačići',
  },
  chat: {
    title: 'Craft Tower Uživo Čat',
    subtitle: 'Pitajte nas bilošta u realnom vremenu',
    online: 'Na mreži',
    welcomeMsg: 'Zdravo! Kako vam možemo pomoći u realizaciji projekta?',
    namePromptTitle: 'Dobrodošli na Uživo Čat',
    namePromptSubtitle: 'Unesite vaše ime da započnete razgovor:',
    namePlaceholder: 'Unesite vaše ime...',
    nameSubmit: 'Započni čat',
    chattingAs: 'Razgovarate kao',
    edit: 'Izmijeni',
    placeholder: 'Napišite vašu poruku...',
    send: 'Pošalji',
    sending: 'Slanje…',
    adminTitle: 'Craft Tower Tim',
    aiAssistantTitle: 'CT-Agent AI (Gemma 4)',
    you: 'Vi',
    modeAi: 'AI Asistent',
    modeHuman: 'Tim Uživo',
    modeHumanNotice: 'U režimu ste razgovora sa timom. Ostavite poruku i naš tim će vam odgovoriti direktno putem Telegrama u toku radnog vremena (10:00–16:00)!',
    roundBadge: 'Runda',
    limitNotice: 'Dostignut je dnevni limit konsultacija (10/10 rundi). Naš tim je primio vaš transkript na Telegramu i javiće se u toku radnog vremena (10:00–16:00).',
    sessionTerminatedNotice: 'Sesija je zatvorena (upiti van djelatnosti CRAFT TOWER-a). Za saradnju pišite na info@craft-tower.com.',
    unreadMsg: 'Nova poruka od Craft Tower tima',
    offlineNotice: 'Čat uživo trenutno nije dostupan. Možete nam poslati poruku putem forme ili na info@craft-tower.com.',
    notificationsTooltip: 'Omogući obavještenja za odgovore operatera',
    notificationsActive: 'Obavještenja su aktivna',
    soundMute: 'Isključi zvuk čata',
    soundUnmute: 'Uključi zvuk čata',
    export: 'Izvezi transkript',
    downloadMd: 'Preuzmi Markdown (.md)',
    downloadPdf: 'Štampaj / Sačuvaj kao PDF',
    emailSummary: 'Pošalji na email',
    emailPromptTitle: 'Zatražite sažetak konsultacije',
    emailPromptSubtitle: 'Unesite vaš email za prijem transkripta i sažetka upita:',
    emailPlaceholder: 'vas@email.com',
    emailSubmit: 'Pošalji na email',
    emailSentSuccess: 'Sažetak upita je poslat na vaš email!',
    systemNotice: 'Sistemsko obavještenje',
    verificationNotice: 'Sigurnosna verifikacija nije uspjela. Ako koristite ad-blocker ili privacy ekstenziju, dozvolite challenges.cloudflare.com ili pokušajte ponovo.',
  },
  footer: {
    made: 'Dizajnirano i razvijeno u Baru, Crna Gora.',
    rights: 'Sva prava zadržana.',
    oldSite: 'Stari sajt',
  },
  cyber: {
    hero: {
      title: 'Digitalna evolucija',
      titleAccent: 'je pred nama.',
      description:
        'Dobrodošli na ivicu tehnologije. Mi ne pišemo samo kod—mi arhitektujemo visoko performantne digitalne sisteme za novo doba.',
      slogan: 'Čist kod. Umjetna inteligencija. Dobrodošli u mrežu.',
    },
    about: {
      p1: 'Tehnologija ne bi smjela da vas usporava. Bilo da automatizujete procese pomoću AI-a, podižete zaštićenu serversku mrežu ili lansirate naprednu veb aplikaciju, mi uklanjamo sav korporativni šum.',
      p2: 'Isporučujemo čist kod, bezbjedne sisteme i inovativna rješenja koja vas drže korak ispred. Povežite se na mrežu i izgradimo nešto izvanredno.',
    },
  },
}
